import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: "ri-passport-line",
      titleKey: "service1Title",
      descKey: "service1Desc",
      features: ["技術・人文知識・国際業務", "技能実習", "特定技能", "家族滞在・配偶者ビザ", "永住権申請"]
    },
    {
      icon: "ri-building-line",
      titleKey: "service2Title",
      descKey: "service2Desc",
      features: ["株式会社設立", "合同会社設立", "経営管理ビザ申請", "事業計画書作成", "定款作成"]
    },
    {
      icon: "ri-hammer-line",
      titleKey: "service3Title",
      descKey: "service3Desc",
      features: ["一般建設業許可", "特定建設業許可", "業種追加", "更新申請", "経営事項審査"]
    },
    {
      icon: "ri-flag-line",
      titleKey: "service4Title",
      descKey: "service4Desc",
      features: ["帰化許可申請", "必要書類収集", "面接対策", "申述書作成", "中国領事館手続き"]
    },
    {
      icon: "ri-truck-line",
      titleKey: "service5Title",
      descKey: "service5Desc",
      features: ["一般貨物自動車運送事業", "貨物軽自動車運送事業", "運輸開始届", "事業報告書", "巡回指導対応"]
    },
    {
      icon: "ri-file-list-3-line",
      titleKey: "service6Title",
      descKey: "service6Desc",
      features: ["飲食店営業許可", "古物商許可", "酒類販売業免許", "宅建業免許", "介護事業許可"]
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            {t('services')}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-slate-100 group">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-4">{t(service.titleKey)}</h3>
              <p className="text-slate-600 leading-relaxed mb-4">{t(service.descKey)}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-50 to-cyan-50 rounded-3xl p-12 text-center">
          <div className="w-20 h-20 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-8">
            <i className="ri-translate-2 text-white text-3xl"></i>
          </div>
          <h3 className="text-3xl font-bold text-slate-800 mb-6">
            {t('chineseSupportTitle')}
          </h3>
          <p className="text-xl text-slate-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            {t('chineseSupportDesc')}
          </p>
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <i className="ri-chat-3-line text-teal-500 text-2xl mb-4"></i>
              <h4 className="font-bold text-slate-800 mb-2">{t('chineseConsultation')}</h4>
              <p className="text-sm text-slate-600">{t('chineseConsultationDesc')}</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <i className="ri-file-text-line text-teal-500 text-2xl mb-4"></i>
              <h4 className="font-bold text-slate-800 mb-2">{t('documentTranslation')}</h4>
              <p className="text-sm text-slate-600">{t('documentTranslationDesc')}</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <i className="ri-phone-line text-teal-500 text-2xl mb-4"></i>
              <h4 className="font-bold text-slate-800 mb-2">{t('support24h')}</h4>
              <p className="text-sm text-slate-600">{t('support24hDesc')}</p>
            </div>
          </div>
          <a 
            href="#contact" 
            className="bg-teal-500 text-white px-10 py-4 rounded-full text-lg font-medium hover:bg-teal-600 transition-colors inline-flex items-center gap-3 whitespace-nowrap"
          >
            {t('consultInChinese')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
